import { ProfileCompletionBar } from "PFApp/components/profile_completion_bar/profile_completion_bar";
import { useProfileCompletionLevel } from "PFApp/use_profile_completion_level";
import { Typography } from "PFComponents/typography";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { Tile } from "../../components";
import css from "./profile_completion.module.scss";

export const ProfileCompletion = () => {
  const history = useHistory();
  const { t } = useTranslation("marketplace", { keyPrefix: "dashboard.profileCompletion" });
  const { completionLevel } = useProfileCompletionLevel();

  return (
    <Tile
      title={t("title")}
      label={t("action")}
      onClick={() => history.push("/profiles/me")}
      iconName="profile"
    >
      <div className={css.content}>
        <ProfileCompletionBar />
        <Typography variant="bodyBold" noMargin>
          {t(`progressEvaluation.${completionLevel}`)}
        </Typography>
        <Typography variant="labelRegular" noMargin>
          {t(`progressDescription.${completionLevel}`)}
        </Typography>
      </div>
    </Tile>
  );
};
